import axios from 'axios';

// Sito ecommerce → Avvisi: richieste "avvisami quando torna disponibile" e "se il prezzo scende" con il loro esito
const state = {
	items: [],
	summary: null,
};

const getters = {
	getItems: state => state.items,
	getSummary: state => state.summary,
};

const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const url = (context, path) => `${context.rootGetters['settings/getUrl']}${path}`;

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		const filters = settings.filters || {};
		return axios
			.post(
				url(context, 'alerts'),
				{
					data: {
						sortBy: sortBy[0],
						sortDesc: sortDesc[0] ? 1 : 0,
						page,
						itemsPerPage,
						search: settings.search,
						type: filters.type || 'available',
						status: filters.status || '',
						from: filters.from || '',
						to: filters.to || '',
					},
				},
				auth(context),
			)
			.then(res => {
				context.commit('setItems', res.data.data);
				return res.data.pagination;
			})
			.catch(err => console.log('errore', err));
	},
	// i numeri in testa seguono il periodo scelto, non lo stato
	fetchSummary: async (context, { type, from, to } = {}) => {
		const res = await axios.get(url(context, 'alerts/summary'), { ...auth(context), params: { type: type || 'available', from: from || undefined, to: to || undefined } });
		context.commit('setSummary', res.data.data);
		return res.data.data;
	},
	cancel: async (context, { item, type }) => (await axios.put(url(context, `alerts/${item._id}/cancel`), {}, { ...auth(context), params: { type } })).data.data,
	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setSummary', null);
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
	setSummary: (state, value) => {
		state.summary = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
